import resolveRequest from '../../utils/resolveRequest.js'
import axios from 'axios'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

export default (siteId) => {
  const endpoint = `${apiEndpoints.sites}/${siteId}/configurations`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.get(URL, { withCredentials: true }))
}
